import { render, staticRenderFns } from "./FrzCtnResponsibleStop.vue?vue&type=template&id=7133b65c"
import script from "./FrzCtnResponsibleStop.vue?vue&type=script&lang=js"
export * from "./FrzCtnResponsibleStop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports